<template>
  <div
    class="shane_tm_talk bg_image_props"
    :style="{ backgroundImage: 'url(' + imgSrc + ')' }"
    id="contact"
    ref="contact"
  >
    <img
    src="../../assets/img/backgrounds/cuttingBoardTransparent.png"
    style="width: 600px;
          position: absolute;
          right: -200px;
          top: -400px;
          z-index: 3;
          transform: rotate(20deg);"
    />
    <div class="shape">
      <img
        class="svg"
        src="../../assets/img/svg/paper.svg"
        alt="partners brand"
      />
    </div>
    <!-- End shape -->

    <div class="background" id="talk">
      <a class="player"></a>
      <!-- <div class="overlay"></div> -->
    </div>
    <!-- End background -->

    <div class="talk_inner">
      <div class="text" v-scroll-reveal="{ delay: 100 }">
        <div class="title" style="margin-bottom: 30px;">
          <h2 style="color: white;">Get in Touch</h2>
        </div>
        <div class="left">
          <div class="fields">
            <Contact />
          </div>
        </div>
        <br/><br/>
        <div style="color: white;">
          Or call<br/><b><a href="tel:904-549-9245" style="color: white;">904-549-9245</a></b>
        </div>
      </div>
      <!-- <div class="button" v-scroll-reveal="{ delay: 200 }">
        <button class="white-fill-bg" @click="showModal">
          Make an enquiry
        </button>
      </div> -->
    </div>
    <!-- End talk_inner -->

    <!-- Start Modalbox -->
    <transition name="fade">
      <!-- Modal -->
      <div
        :class="{ 'modal-mask': isActive }"
        id="modal"
        @click="closeModal"
        v-if="isVisible"
      >
        <div class="modal-dialog modal-dialog-centered " @click.stop>
          <div class="modal-content calltoactions-content">
            <div class="close" @click="closeModal">
              <img
                class="svg"
                src="../../assets/img/svg/cancel.svg"
                alt="cancel-img"
              />
            </div>
            <!-- End .close -->

            <div class="shane_tm_mobalbox_contact">
              <div class="box_inner">
                <div class="title">
                  <h3>Get in Touch</h3>
                </div>

                <div class="wrapper">
                  <div class="left">
                    <div class="fields">
                      <Contact />
                    </div>
                  </div>
                  <!-- End left -->
                  <div class="right">
                    <div class="map_wrap">
                      <Map />
                    </div>
                  </div>
                  <!-- End right -->
                </div>
                <!-- End wrapper -->

                <div class="short_info">
                  <ul>
                    <li>
                      <div class="list_inner">
                        <img
                          class="svg"
                          src="../../assets/img/svg/location.svg"
                          alt="location"
                        />
                        <p>Brook 103, 90021 New York, USA</p>
                      </div>
                    </li>
                    <!-- End silgle address -->

                    <li>
                      <div class="list_inner">
                        <img
                          class="svg"
                          src="../../assets/img/svg/phone.svg"
                          alt="phone"
                        />
                        <p>
                          <a href="tel:+77 033 442 55 57">+77 033 442 55 57</a>
                        </p>
                      </div>
                    </li>
                    <!-- End silgle address -->

                    <li>
                      <div class="list_inner">
                        <img
                          class="svg"
                          src="../../assets/img/svg/share.svg"
                          alt="share"
                        />

                        <Social />
                      </div>
                    </li>
                    <!-- End silgle address -->
                  </ul>
                </div>
                <!-- End modal conetent -->
              </div>
              <!-- End box inner -->
            </div>
            <!-- End modalbox news -->
          </div>
        </div>
      </div>
    </transition>
    <!-- End Modalbox -->
  </div>
  <!-- Start Modal -->
</template>

<script>
import Contact from "../Contact.vue";
import Map from "../Map.vue";
import Social from "../Social.vue";
export default {
  components: {
    Contact,
    Map,
    Social,
  },
  data() {
    return {
      imgSrc: require("../../assets/img/backgrounds/woodBackground.jpeg"),
      isActive: false,
      isVisible: false,
    };
  },
  methods: {
    showModal: function() {
      this.isActive = true;
      this.isVisible = true;
    },
    closeModal: function() {
      this.isActive = false;
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
